import { cva } from '@/styled-system/css';

export const layoutRootRecipe = cva({
  base: {
    display: 'grid',
    gap: 'Layout.Root.gap',
    justifyContent: 'center',
  },
  variants: {
    template: {
      fluid12: {
        gridTemplateColumns: 'repeat(12, minmax(0, 1fr))',
      },
      fixed12: {
        gridTemplateColumns: 'repeat(auto-fit, {sizes.Layout.Root.fixed})',
      },
      auto: {
        gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
      },
    },
  },
});
